
import pageMixin from "@/mixins/pageMixin"
import GetQuoteHero from "@/components/blocks/GetQuoteHero"
import ErrorReporter from "@soenergy/frontend-library/src/services/ErrorReporter"
import ContentBlockList from "@soenergy/frontend-library/src/components/ContentBlockList"
import Referral from "@/services/Referral.js"
import TrackingService from "@soenergy/frontend-library/src/services/TrackingService"

export default {
  components: {
    GetQuoteHero,
    ContentBlockList
  },
  storyId: "referral-landing-page",
  mixins: [pageMixin],
  asyncData({ $storyblokHelper }) {
    return $storyblokHelper.get({ id: "referral-landing-page" })
  },
  data() {
    return {
      voucherValid: false,
      errorMessage: null,
      cookieName: "voucher",
      cookieDuration: "1h",
      referrer: null,
      testVoucher: "123456"
    }
  },
  computed: {
    voucher() {
      return this.$route.query.id
    }
  },
  mounted() {
    this.checkVoucher()
  },
  methods: {
    checkVoucher() {
      if (this.voucher === this.testVoucher) {
        this.voucherValid = true
        this.referrer = "Bob"
      } else {
        Referral.checkVoucher(this.voucher)
          .then(response => {
            console.log("response", response)
            this.errorMessage = null
            this.setCookie()
            this.voucherValid = true
            this.referrer = response.data.referrer
            TrackingService.sendEvent("voucherInitialCheckSuccessful")
          })
          .catch(error => {
            console.log(error)
            this.errorMessage = "An error has occured"
            this.voucherValid = false
            ErrorReporter.report(error)
          })
      }
    },
    setCookie() {
      try {
        this.$cookies.set(this.cookieName, this.voucher, this.cookieDuration)
        this.$cookies.remove("promotional_code_used")
      } catch (error) {
        console.log(error)
        this.errorMessage = "An error has occured"
        ErrorReporter.report(error)
      }
    }
  }
}
